/* eslint-disable @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
import { useTranslation } from "react-i18next";
import styles from "./RenderModalFooter.module.scss";

interface RenderModalProps {
  productData: any;
  setSelectedCargoIds: (state: any) => void;
  selectedCargoIds: any;
  containerVolume: number;
}

export const RenderModalFooter = ({
  productData,
  selectedCargoIds: _selectedCargoIds,
  setSelectedCargoIds: _setSelectedCargoIds,
  containerVolume,
}: RenderModalProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles["cargo-list-wrap"]}>
      <ul className={styles["cargo-list"]}>
        {productData.map((product: any, index: number) => {
          const volumePercent = Math.round((product.volume / containerVolume) * 100);
          const name = product.name.toLowerCase();

          return (
            <li key={`${product.uid}_${index}`} className={styles["cargo-list-item"]}>
              <div style={{ backgroundColor: product.color }} className={styles["cargo-color"]} />
              <div className={styles["cargo-name"]} title={`${t(name)} x${product.qty}`}>
                {t(name)} x{product.qty}
              </div>
              <div className={styles["cargo-qty"]}>
                ({volumePercent}% {t("of volume")})
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

// const eye = (
//   <svg
//     width='15'
//     height='10'
//     viewBox='0 0 15 10'
//     fill='none'
//     xmlns='http://www.w3.org/2000/svg'
//   >
//     <path
//       opacity='0.4'
//       d='M14.8058 4.83897C13.4769 2.24612 10.8461 0.491821 7.83373 0.491821C4.82136 0.491821
//             2.18979 2.24734 0.86163 4.83921C0.805574 4.9501 0.776367 5.07261 0.776367 5.19686C0.776367
//             5.32111 0.805574 5.44362 0.86163 5.55451C2.19052 8.14736 4.82136 9.90166 7.83373 9.90166C10.8461
//             9.90166 13.4777 8.14613 14.8058 5.55426C14.8619 5.44338 14.8911 5.32087 14.8911 5.19662C14.8911
//             5.07237 14.8619 4.94986 14.8058 4.83897ZM7.83716 8.72543H7.83373C6.89847 8.72497 6.00168 8.35306
//             5.34059 7.69149C4.6795 7.02992 4.30825 6.13286 4.30847 5.1976C4.3087 4.26233 4.68039 3.36546 5.3418
//             2.70421C6.00321 2.04295 6.90018 1.67148 7.83545 1.67148C8.77071 1.67148 9.66768 2.04295 10.3291
//             2.70421C10.9905 3.36546 11.3622 4.26233 11.3624 5.1976C11.3626 6.13286 10.9914 7.02992 10.3303
//             7.69149C9.66921 8.35306 8.77242 8.72497 7.83716 8.72543Z'
//     />
//     <path
//       d='M10.1041 5.80613C10.0241 6.10434 9.88595 6.38383 9.6977 6.62857C9.50944 6.87332 9.27475
//           7.07852 9.00706 7.2324C8.73937 7.38629 8.44395 7.48585 8.13772 7.52537C7.83148 7.56489 7.52046
//           7.5436 7.22248 7.46272C6.92449 7.38183 6.64539 7.24294 6.40116 7.05401C6.15694 6.86508 5.9524
//           6.62981 5.79926 6.3617C5.64612 6.09358 5.54738 5.79788 5.50871 5.49154C5.47004 5.1852 5.4922
//           4.87424 5.57391 4.57648C5.79977 4.74267 6.07771 4.82243 6.35732 4.80128C6.63693 4.78012 6.89971
//           4.65946 7.09799 4.46118C7.29627 4.2629 7.41693 4.00013 7.43808 3.72051C7.45923 3.4409 7.37948
//           3.16296 7.21328 2.93711C7.61217 2.82325 8.03419 2.81769 8.43593 2.92101C8.83768 3.02432 9.20466
//           3.23279 9.49913 3.52496C9.79359 3.81713 10.0049 4.18246 10.1114 4.58339C10.2178 4.98431 10.2156
//           5.40636 10.1048 5.80613H10.1041Z'
//     />
//   </svg>
// );
